import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BaseComponent, WmsDialogBodyComponent, WmsSpinnerComponent} from "@wms/components";
import {PreferenceService, StudioService, UserService} from "@wms/services";
import {get} from "lodash-es";
import moment, {unix} from "moment";



@Component({
  selector: 'wms-about-dialog',
  standalone: true,
  imports: [CommonModule, WmsDialogBodyComponent ],
  templateUrl: './about-dialog.component.html',
  styleUrls: ['./about-dialog.component.less']
})
export class AboutDialogComponent  extends BaseComponent implements OnInit{
  @Input() studioInfo:any
  @Output() handleClose = new EventEmitter<any>();
  product:any;
  platformVer :string='';
  releaseDate:any;
  releaseDocVersion:number;
  studioUIVersion:number;
  appRuntimeUIVersion:number
  appRuntimeServicesVersion:number;
  user:any;
  studioPreferences:any;


  constructor( private userService:UserService,
               private studioService :StudioService) {
    super();
    this.studioPreferences = inject(PreferenceService);
  }

  ngOnInit() {
    this.user = this.userService.get()
      this.product = this.studioInfo.product;

      if (this.studioPreferences.hasAccess('workspace.user.11_beta_enabled')) {
        this.platformVer = get(this.product, 'platformVersion');
      } else {
        this.platformVer = get(this.product, 'platformSupportedVersions[0]');
        // If platformSupportedVersion is null or "NA" then using studio platformVersion
        if (!get(this.product, 'platformSupportedVersions') || get(this.product, 'platformSupportedVersions[0]') == 'NA') {
          this.platformVer = get(this.product, 'platformVersion');
        }
      }


      let serviceVersions = this.product['serviceVersions'][this.platformVer] || get(this.product['serviceVersions'], this.product?.latestReleaseVersion);
      let date = unix(this.product.releaseDate)
      this.releaseDate = moment(date).valueOf()
      this.releaseDocVersion = this.product.platformVersion.replace(/[.]/g, '-');
      this.studioUIVersion = serviceVersions['wavemaker.studio.version'];
      this.appRuntimeUIVersion = serviceVersions['wavemaker.app.runtime.ui.version'];
      this.appRuntimeServicesVersion = serviceVersions['wavemaker.app.runtime.services.version'];


  }


  closeDialog() {
    this.handleClose.emit();
  };

}
